var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodInox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 636,
    viewBox: "0 0 424 636",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32335_26862)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 424,
    height: 636,
    fill: "#12264F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0862 525.394L62.8116 513.433L53.6709 505.389L65.7468 504.327L70.4431 493.047L75.1393 504.327L87.2152 505.389L78.0745 513.433L80.7999 525.394L70.4431 519.053L60.0862 525.394Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.431 84.6675L343.975 73.5048L335.443 65.9969L346.714 65.0037L351.097 54.4766L355.48 65.0037L366.752 65.9969L358.22 73.5048L360.762 84.6675L351.097 78.7485L341.431 84.6675Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.1138 234.488L-7.5698 223.325L-16.1013 215.817L-4.83043 214.824L-0.447396 204.297L3.9359 214.824L15.2068 215.817L6.67526 223.325L9.219 234.488L-0.447396 228.569L-10.1138 234.488Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.113 580.44L346.657 569.277L338.126 561.77L349.397 560.778L353.78 550.25L358.164 560.778L369.435 561.77L360.902 569.277L363.446 580.44L353.78 574.521L344.113 580.44Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2247 97.6065L65.8588 81.6599L53.6709 70.9342L69.7722 69.5152L76.0337 54.4766L82.2955 69.5152L98.3967 70.9342L86.2089 81.6599L89.8429 97.6065L76.0337 89.1509L62.2247 97.6065Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.86 263.323L416.677 255.349L410.582 249.986L418.633 249.277L421.765 241.758L424.894 249.277L432.944 249.986L426.853 255.349L428.669 263.323L421.765 259.095L414.86 263.323Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.557 351.029H129.706L128.971 352.788H127L130.7 344.578H132.599L136.311 352.788H134.298L133.563 351.029H133.557ZM132.954 349.586L131.64 346.444L130.327 349.586H132.96H132.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.926 347.589C148.926 349.442 147.537 350.595 145.315 350.595H143.643V352.888H141.717V344.578H145.315C147.537 344.578 148.926 345.731 148.926 347.595M146.982 347.589C146.982 346.672 146.39 346.141 145.213 346.141H143.649V349.026H145.213C146.39 349.026 146.982 348.489 146.982 347.589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.838 344.578L155.23 352.788H153.329L149.727 344.578H151.815L154.352 350.445L156.919 344.578H158.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.392 352.882L163.799 350.566H162.044V352.882H160.139V344.578H163.709C165.914 344.578 167.291 345.73 167.291 347.593C167.291 348.842 166.668 349.752 165.596 350.216L167.447 352.888H165.398L165.392 352.882ZM163.601 346.146H162.044V349.041H163.601C164.769 349.041 165.356 348.498 165.356 347.593C165.356 346.689 164.769 346.146 163.601 346.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.357 344.578H173.455V352.788H175.357V344.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.569 344.578V352.788H183.99L179.857 347.804V352.788H177.96V344.578H179.55L183.671 349.562V344.578H185.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.571 348.688C187.571 346.215 189.501 344.383 192.127 344.383C194.752 344.383 196.682 346.203 196.682 348.688C196.682 351.173 194.74 352.993 192.127 352.993C189.513 352.993 187.571 351.161 187.571 348.688ZM194.734 348.688C194.734 347.104 193.615 346.021 192.127 346.021C190.638 346.021 189.519 347.104 189.519 348.688C189.519 350.272 190.638 351.354 192.127 351.354C193.615 351.354 194.734 350.272 194.734 348.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.671 352.788L201.666 349.938L199.692 352.788H197.482L200.561 348.614L197.639 344.578H199.825L201.733 347.243L203.61 344.578H205.687L202.789 348.543L205.892 352.788H203.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.907 351.261V352.788H211.499V344.578H217.756V346.104H213.404V347.887H217.245V349.366H213.404V351.261H217.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.221 352.788L223.239 349.938L221.287 352.788H219.108L222.147 348.614L219.257 344.578H221.418L223.311 347.243L225.161 344.578H227.221L224.355 348.543L227.418 352.788H225.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.029 347.589C236.029 349.442 234.64 350.595 232.418 350.595H230.746V352.888H228.82V344.578H232.418C234.64 344.578 236.029 345.731 236.029 347.595M234.079 347.589C234.079 346.672 233.487 346.141 232.31 346.141H230.74V349.026H232.31C233.487 349.026 234.079 348.489 234.079 347.589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.438 351.261V352.788H238.03V344.578H244.282V346.104H239.93V347.887H243.771V349.366H239.93V351.261H244.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.888 352.882L250.301 350.566H248.545V352.882H246.64V344.578H250.211C252.415 344.578 253.793 345.73 253.793 347.593C253.793 348.842 253.17 349.752 252.098 350.216L253.949 352.888H251.9L251.888 352.882ZM250.097 346.146H248.539V349.041H250.097C251.265 349.041 251.852 348.498 251.852 347.593C251.852 346.689 251.265 346.146 250.097 346.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.853 344.578H255.951V352.788H257.853V344.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.865 351.261V352.788H260.457V344.578H266.708V346.104H262.356V347.887H266.197V349.366H262.356V351.261H266.865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.575 344.578V352.788H274.997L270.864 347.804V352.788H268.967V344.578H270.557L274.678 349.562V344.578H276.575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.678 348.682C278.678 346.176 280.6 344.383 283.178 344.383C284.612 344.383 285.811 344.908 286.588 345.856L285.353 346.997C284.799 346.357 284.094 346.025 283.269 346.025C281.714 346.025 280.618 347.118 280.618 348.688C280.618 350.258 281.72 351.351 283.269 351.351C284.1 351.351 284.799 351.018 285.353 350.366L286.588 351.508C285.805 352.468 284.612 352.993 283.166 352.993C280.594 352.993 278.678 351.2 278.678 348.694",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.897 351.261V352.788H288.489V344.578H294.747V346.104H290.395V347.887H294.236V349.366H290.395V351.261H294.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.636 333.259H246.541L262.725 308.853L248.176 286.268H264.964L271.324 298.266L279.796 283H297L279.386 308.853L294.912 333.259H278.028L270.944 320.212L263.636 333.259Z",
    fill: "#EEECDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.018 286.297H127V333.252H142.018V286.297Z",
    fill: "#EEECDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.327 333.252V286.297H164.275L180.015 311.443V286.297H194.379V333.252H180.111L164.716 308.72V333.252H150.327Z",
    fill: "#EEECDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.466 286.297C212.501 286.297 201.989 296.805 201.989 309.771C201.989 322.738 212.501 333.252 225.466 333.252C238.431 333.252 248.944 322.738 248.944 309.771C248.944 296.805 238.431 286.297 225.466 286.297ZM225.466 318.297C220.761 318.297 216.941 314.483 216.941 309.771C216.941 305.06 220.761 301.252 225.466 301.252C230.171 301.252 233.991 305.066 233.991 309.771C233.991 314.477 230.171 318.297 225.466 318.297Z",
    fill: "#EEECDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32335_26862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 424,
    height: 636,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodInox);
export default __webpack_public_path__ + "static/media/food-inox.add7542e09d5752210ed5f3b9decdec3.svg";
export { ForwardRef as ReactComponent };